import React, { useState } from "react";
import Head from "../../layout/head/Head";
import Content from "../../layout/content/Content";
import { Badge } from "reactstrap";
import {
  BlockHeadContent,
  BlockTitle,
  BlockBetween,
  BlockHead,
  Icon,
} from "../../components/Component";
import { Button } from "reactstrap";
import BasePaginationTable from "../../components/table/BasePaginationTable";
import UpdateAdminModal from "./modals/UpdateAdminModal";
import DeleteConfirmationModal from "./modals/DeleteConfimationModal";
import TableActions from "../../components/table/TableActions";
import TableTime from "../../components/table/TableTime";
function getDefaultColumns(onEditClick, onDeleteClick) {
  return [
    {
      head: <span className="sub-text">{"Name"}</span>,
      cell: (row) => <span>{row.name}</span>,
    },
    {
      head: <span className="sub-text">{"Email"}</span>,
      cell: (row) => <span>{row.email}</span>,
    },

    {
      head: <span className="sub-text">{"Address"}</span>,
      cell: (row) => <span>{row.address}</span>,
    },
    {
      head: <span className="sub-text">{"Role"}</span>,
      cell: (row) => <span>{row.role}</span>,
    },
    {
      head: <span className="sub-text">{"Joined Date"}</span>,
      cell: (row) => <TableTime value={row?.createdAt} />,
    },
    {
      head: <span className="sub-text">{"Status"}</span>,
      cell: (row) => (
        <span>
          <Badge
            className="badge-sm badge-dot has-bg d-none d-sm-inline-flex"
            color={row.verified ? "success" : "warning"}
          >
            {row.verified ? "Deactive" : "Active"}
          </Badge>
        </span>
      ),
    },
    {
      head: <span className="sub-text"></span>,
      cellClassName: "nk-tb-col-tools",
      cell: (row) => (
        <TableActions
          actions={[
            { label: "Edit", icon: "eye", onClick: () => onEditClick(row) },
            {
              label: "Delete",
              icon: "delete",
              danger: true,
              onClick: () => onDeleteClick(row),
            },
          ]}
        />
      ),
    },
  ];
}
const AdminsPage = () => {
  const [smOption, setSmOption] = useState(false);
  const onDelete = (admin) => {
    setAdminModalVisible({ admin, delete: true });
  };
  const list = [
    {
      name: "nguyedinhan",
      email: "nguyedinhan@gmail.com",
      role: "Forum Manager",
      createdAt: "2024-01-22T02:36:48.432Z",
      address: "3445 Bubby Drive",
      verified: false,
    },
    {
      name: "nguyedinhan",
      email: "nguyedinhan@gmail.com",
      role: "Forum Manager",
      createdAt: "2024-01-22T02:36:48.432Z",
      address: "3445 Bubby Drive",
      verified: false,
    },
    {
      name: "nguyedinhan",
      email: "nguyedinhan@gmail.com",
      role: "Service Provider Manager",
      createdAt: "2024-01-22T02:36:48.432Z",
      address: "3445 Bubby Drive",
      verified: false,
    },
    {
      name: "nguyedinhan",
      email: "nguyedinhan@gmail.com",
      role: "Service Provider Manager",
      createdAt: "2024-01-22T02:36:48.432Z",
      address: "3445 Bubby Drive",
      verified: false,
    },
    {
      name: "nguyedinhan",
      email: "nguyedinhan@gmail.com",
      role: "Service Provider Manager",
      createdAt: "2024-01-22T02:36:48.432Z",
      address: "3445 Bubby Drive",
      verified: false,
    },
    {
      name: "nguyedinhan",
      email: "nguyedinhan@gmail.com",
      role: "Service Provider Manager",
      createdAt: "2024-01-22T02:36:48.432Z",
      address: "3445 Bubby Drive",
      verified: false,
    },
  ];
  const [isAdminModalVisible, setAdminModalVisible] = useState({
    admin: null,
    update: false,
    delete: false,
  });

  const openModal = (admin) => {
    setAdminModalVisible({ admin, update: true });
  };
  const closeModal = () => {
    setAdminModalVisible({
      admin: null,
      delete: false,
      update: false,
    });
  };
  const dataTableColumns = getDefaultColumns(openModal, onDelete);
  return (
    <React.Fragment>
      <Head title="Admins"></Head>
      <Content>
        <BlockHead size="sm">
          <BlockBetween>
            <BlockHeadContent>
              <BlockTitle>Admins</BlockTitle>
            </BlockHeadContent>
            <BlockHeadContent>
              <div className="toggle-wrap nk-block-tools-toggle">
                <a
                  href="#more"
                  className="btn btn-icon btn-trigger toggle-expand me-n1"
                  onClick={(ev) => {
                    ev.preventDefault();
                    setSmOption(!smOption);
                  }}
                >
                  <Icon name="more-v"></Icon>
                </a>
                <div
                  className="toggle-expand-content"
                  style={{ display: smOption ? "block" : "none" }}
                >
                  <ul className="nk-block-tools g-3">
                    <li className="nk-block-tools-opt">
                      <Button
                        className="toggle btn-icon d-md-none"
                        color="primary"
                        onClick={() => {
                          openModal();
                        }}
                      >
                        <Icon name="plus"></Icon>
                      </Button>
                      <Button
                        className="toggle d-none d-md-inline-flex"
                        color="primary"
                        onClick={() => {
                          openModal();
                        }}
                      >
                        <Icon name="plus"></Icon>
                        <span>Add Admin</span>
                      </Button>
                    </li>
                  </ul>
                </div>
              </div>
            </BlockHeadContent>
          </BlockBetween>
        </BlockHead>
        <BasePaginationTable
          list={list}
          columns={dataTableColumns}
          hasNextPage={false}
          totalItems={list.length}
        />
      </Content>
      <UpdateAdminModal
        admin={isAdminModalVisible.admin}
        isOpen={isAdminModalVisible.update}
        closeModal={closeModal}
      />
      <DeleteConfirmationModal
        isOpen={isAdminModalVisible.delete}
        onCloseModal={closeModal}
      />
    </React.Fragment>
  );
};

export default AdminsPage;
